var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.857 9.42871H5.14275C4.19599 9.42871 3.42847 10.1962 3.42847 11.143V21.4287C3.42847 22.3755 4.19599 23.143 5.14275 23.143H18.857C19.8038 23.143 20.5713 22.3755 20.5713 21.4287V11.143C20.5713 10.1962 19.8038 9.42871 18.857 9.42871Z",
    stroke: "#FAAD14",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.42885V6.85742C18 5.26612 17.3679 3.73999 16.2426 2.61479C15.1174 1.48956 13.5913 0.857422 12 0.857422C10.4087 0.857422 8.88257 1.48956 7.75737 2.61479C6.63214 3.73999 6 5.26612 6 6.85742V9.42885",
    stroke: "#FAAD14",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.143C12.4733 17.143 12.8571 16.7592 12.8571 16.2859C12.8571 15.8125 12.4733 15.4287 12 15.4287C11.5266 15.4287 11.1428 15.8125 11.1428 16.2859C11.1428 16.7592 11.5266 17.143 12 17.143Z",
    stroke: "#FAAD14",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlock_icon.73307a442ffcd99699c9f69e67733032.svg";
export { ForwardRef as ReactComponent };